/**
 * A Facebook ranking clip not linked to a Page the clipper connected: a
 * reviewer confirms its ownership and its views are unverified public
 * observations. A clip linked to a connected Page follows the native path,
 * like Instagram. A missing `connected_account` (older backend) stays manual.
 */
export function isManualFacebookReport(report: { platform?: string | null; connected_account?: boolean | null }): boolean {
  return report.platform === 'facebook' && report.connected_account !== true;
}
